import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"

const CohortSwitcherBlankSlate = ({ search }) => {
  const { t } = useTranslate()

  return search ? (
    <BlankSlate
      icon="group"
      heading={t(`No Cohorts matching "{{ searchTerm }}" are in progress.`, {
        searchTerm: search
      })}
    />
  ) : (
    <BlankSlate
      icon="group"
      heading={t("No Cohorts are in progress.")}
      body={t(`To start a new Cohort, choose "New" above.`)}
    />
  )
}

export default CohortSwitcherBlankSlate
